import { Injectable, EventEmitter } from '@angular/core';
import { ApiService } from '@api/service';
import { GetDashboardNotifications$Response } from '@api/types';
import { Observable, Subscription, Subject } from 'rxjs';

@Injectable()
export class NotificationService {
  private getDashboardNotifications: Observable<GetDashboardNotifications$Response>;
  needFetch$: EventEmitter<any> = new EventEmitter<any>();

  constructor(private api: ApiService) {}

  getNotificationData(forceFetch?: boolean): Observable<GetDashboardNotifications$Response> {
    if (!this.getDashboardNotifications || forceFetch) {
      this.getDashboardNotifications = this.api.user.getDashboardNotifications();
    }
    return this.getDashboardNotifications;
  }

  weightUpdated() {
    this.needFetch$.emit();
  }

  subscriptionChanged() {
    this.needFetch$.emit();
  }

  cardUpdated() {
    this.needFetch$.emit();
  }
}
